import { defineStore } from "pinia";
import { useAuthStore } from "./auth";
import { useTableStore } from "./table";
import { useSettingStore } from "./setting";
import { useMenuStore } from "./menu";
import { useShopStore } from "./shop";


export const useBootstrapStore = defineStore({
  id: "bootstrap",
  state: () => {
    return {
      loaded: false,
      ready: "splash",
      queue: [] as any[],
      loadHomePage: false,
      loadingList: [
        "Restore Data",
        "Fetch Version",
        "Fetch Shop",
        "Fetch Setting",
        "Fetch Products",
        "Fetch Table",
        "Fetch Jobs",
        "Fetch QR Code",
        "READY",
      ],
      currentLoadingIndex: 0,
    };
  },
  actions: {
    init() {
      const authStore = useAuthStore();
      const tableStore = useTableStore();
      const menuStore = useMenuStore();
      const settingStore = useSettingStore();
      const shopStore = useShopStore();

      this.ready = "splash";
      this.queue = [
        {
          name: "auth",
          fn: authStore.init,
          args: [],
        },
        {
          name: "beta",
          fn: shopStore.fetchBetaWhiteLists,
          args: [],
        },
        {
          name: "shop",
          fn: shopStore.getStoreData,
          args: [],
        },
        {
          name: "setting",
          fn: settingStore.init,
          args: [],
        },
        {
          name: "menu",
          fn: menuStore.init,
          args: [],
        },

        {
          name: "table",
          fn: tableStore.init,
          args: [],
        },
        {
          name: "token",
          fn: authStore.watchRealtimeTokenExpired,
          args: [],
        },
      ];

    },
    async run() {         
      for (let index = 0; index < this.queue.length; index++) {
        const q = this.queue[index];
        this.currentLoadingIndex = index;   
         await q.fn();          
        console.log(`${q.name} is loaded`)
      }
      
      this.currentLoadingIndex = this.loadingList.length - 1;
      this.ready = "ready";
    },
  },
});
